import React from 'react';
import AbstractModalView from 'common/components/AbstractModalView';
import FilesList from "./FilesList";
import ButtonCommon from "../ButtonCommon";
import Empty from '../Empty';
import attach from '../../../modules/InspectedList/assets/attach.svg';
import styles from './styles.module.scss';

const Trigger = ({updateList, openModal}) => {
  return (
    <div
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        openModal();
        updateList();
      }}
      className={styles.triggerContainer}
    >
      <img src={attach} alt="file-present" className={styles.icon}/>
      <p className={styles.label}>מסמכים ואסמכתאות</p>
    </div>
  )
};

const ModalShumaFilesListView = ({
                                   shumaId,
                                   firmShumaID,
                                   files,
                                   updateList
                                 }) => {
  const header = `מסמכים ואסמכתאות - דוח ${firmShumaID}`;

  return (
    <AbstractModalView
      subPath={`view-form-${shumaId}-data-files`}
      modalClassName={styles.modal}
      triggerContent={({openModal}) => (
        <Trigger
          openModal={openModal}
          updateList={updateList}
        />
      )}
      modalContent={({closeModal}) => (
        <div className={styles.modalContainer}>
          <h2 className={styles.modalHeader}>{header}</h2>
          <div className={styles.modalContentContainer}>
            {(files && files.length > 0)
              ?
              <FilesList
                shumaID={shumaId}
                files={files}
              />
              :
              <Empty
                message={'ללא קבצים מצורפים'}
                customContainerClassName={styles.emptyContainer}
              />
            }
          </div>
          <ButtonCommon
            variant={'cancel'}
            label={'סגירה'}
            onClick={() => closeModal()}
            customContainerStyles={styles.buttonContainer}
          />
        </div>
      )}
    />
  )
};

export default ModalShumaFilesListView;
